import { put, fork, take, select, throttle } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../../services/actions';
import * as actions from './actions';


function* getTeamListSuccess() {
  const { success } = yield takeFetch(serviceActions.api.configuration.team.GET_LIST);
  if (success) {
    yield put(actions.init.end({ teamList: success.data }));
    yield put(actions.invalidate.begin());
  }
}

function* fetchSearch({ q }) {
  const { projectId } = yield select(state => state.configuration.project.editor.team);
  yield put(serviceActions.api.configuration.team.getList.request({
    q,
    projects: [projectId],
  }));
  yield fork(getTeamListSuccess);
}

function* init() {
  while (true) {
    const { projectId } = yield take(actions.INIT.BEGIN);
    yield put(serviceActions.api.configuration.team.getList.request({
      projects: [projectId],
    }));
    yield fork(getTeamListSuccess);
  }
}

function* throttleSearch() {
  yield throttle(500, actions.SEARCH, fetchSearch);
}

function* invalidate() {
  while (true) {
    yield take(actions.INVALIDATE.BEGIN);
    const { inactive, teamList } = yield select(state => state.configuration.project.editor.team);
    const items = teamList.filter(val => inactive || val.isActive);
    yield put(actions.invalidate.end({ items }));
  }
}

function* setInactive() {
  while (true) {
    yield take(actions.SET_INACTIVE);
    yield put(actions.invalidate.begin());
  }
}

export default function* team() {
  yield fork(init);
  yield fork(throttleSearch);
  yield fork(invalidate);
  yield fork(setInactive);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/team/saga.js